module.exports = __webpack_public_path__ + "img/basic _ paperclip.1bfcb660.svg";